export default __webpack_public_path__ + "static/media/401.975da1b4.svg";